import type { FetchFilteredTopicsActions } from "domains/filteredTopicList/actionTypes";
import { FetchFilteredTopicsActionsTypes } from "domains/filteredTopicList/actionTypes";

type FilteredTopicsState = { hasPossibleNextPage: boolean; ids: string[]; isFetching: boolean };

const initialState: FilteredTopicsState = { hasPossibleNextPage: true, ids: [], isFetching: false };

export const filteredTopicsReducer = (
  state: FilteredTopicsState = initialState,
  action: FetchFilteredTopicsActions,
): FilteredTopicsState => {
  switch (action.type) {
    case FetchFilteredTopicsActionsTypes.FETCH_FILTERED_TOPICS: {
      return {
        ...state,
        isFetching: true,
      };
    }
    case FetchFilteredTopicsActionsTypes.FETCH_FILTERED_TOPICS_FAILURE: {
      return {
        ...state,
        isFetching: false,
      };
    }
    case FetchFilteredTopicsActionsTypes.FETCH_FILTERED_TOPICS_SUCCESS: {
      const newIds =
        action.meta.offset === 0
          ? [...action.meta.topicIds, ...state.ids.slice(action.meta.topicIds.length)]
          : [...state.ids, ...action.meta.topicIds];
      return {
        ...state,
        hasPossibleNextPage: action.meta.topicIds.length === action.meta.limit,
        ids: newIds,
        isFetching: false,
      };
    }
    case FetchFilteredTopicsActionsTypes.CLEAR_FILTERED_TOPICS: {
      return {
        ids: [],
        isFetching: false,
        hasPossibleNextPage: true,
      };
    }
    default:
      return state;
  }
};
